import { useMemo, useState } from "react"
import FieldInput from "src/libs/scalars"
import IScalarForm, { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { jsonToData } from "src/libs/utilities"

/* Protopia Ecosystem component */
const UserDataScalarWidget = (props: IScalarForm): JSX.Element => {
    return <Scalar 
            { ...props } 
            notClear
            enabledForm={<UserDataScalar {...props} />}
            desabledForm={<UserDataScalarDisable {...props} />}
        />
}
export default UserDataScalarWidget

const UserDataScalar = (props: IScalarForm): JSX.Element => {
    const userData: any                     = useMemo(() => jsonToData(props.value || "{}"), []) 
    const [ display_name, setDisplay_name]  = useState<string>(userData.display_name || "")
    const [ age, setAge]                    = useState<string>(userData.age || "")
    const [ school, setSchool]              = useState<string>(userData.school || "")

    const onChange = () => {
        if(props.onChange) {
            props.onChange(
                JSON.stringify({
                    display_name,
                    age,
                    school
                }),
                "", 
                ""
            )
        }
    }
    const onDisplayName = (value: string) => {
        setDisplay_name(value)
        onChange()
    }

    const oAge = (value: string) => {
        setAge(value)
        onChange()
    }

    const onSchool = (value: string) => {
        setSchool(value)
        onChange()
    }

    return userData.age
        ?
        <div className="container card px-4 my-2">
            <FieldInput
                value={display_name}
                vertical={VerticalType.VERTICAL}
                onChange={ onDisplayName }
                editable
                title={"Display name"}
            />
            <FieldInput
                value={age}
                vertical={VerticalType.VERTICAL}
                onChange={ oAge }
                editable
                title={"Age"}
            />
            <FieldInput
                value={school}
                vertical={VerticalType.VERTICAL}
                onChange={ onSchool }
                editable
                title={"Education organization"}
            />
        </div>
        :
        <></>
}

const UserDataScalarDisable = (props: IScalarForm): JSX.Element => {
    const userData: any = useMemo(() => jsonToData(props.value || "{}"), []) 
    return <div className="container">
        <FieldInput
            value={userData.display_name}
            vertical={VerticalType.VERTICAL}
        />
    </div>
}